import React from 'react';
import { BackBreadcrumb } from './BackBreadcrumb';
import { MultiBreadcrumbs } from './MultiBreadcrumbs';

type BreadProps = {
    type: string,
    links: any,
    url: string,
    text: string
}
  
export const Breadcrumbs = ({ ...props }: BreadProps) => {

    return (
        <div className="row no-gutters breadcrumbs">
            <div className="col-12">
                {props.links && props.links.length > 0 ? <MultiBreadcrumbs links={props.links} />
                : <BackBreadcrumb url={props.url} text={props.text} />}
            </div>
        </div>
    );
}
